import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { ErrorResponse } from '@citruscamps/citrus-client'
import { ROUTES } from '../../constants/routes'
import { UndrawSorry } from '../../images/undraw'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  image?: string
  header?: string
  description?: string | React.JSX.Element
  error?: ErrorResponse | null
  stack?: string
  size?: 'lg' | 'md' | 'sm' | 'xs'
  hideButton?: boolean
  align?: 'left' | 'center' | 'right'
}

export const ErrorContent = ({
  image = UndrawSorry,
  header = 'Somethings missing',
  description = 'Looks like something went wrong loading what you are looking for. Try going back to the previous page or try contacting our support for assistance.',
  error,
  stack,
  children,
  size = 'sm',
  hideButton = false,
  align = 'center',
  ...props
}: React.PropsWithChildren<IProps>): React.ReactElement => {
  const [isDevCount, setIsDevCount] = useState<number>(0)
  if (error?.code && error?.code >= 500) {
    header = 'Well isn’t this embarrassing?'
    description = error.message || description
  } else if (error?.code && error?.code === 404) {
    header = 'Are you lost?'
    description =
      error.message ||
      'Looks like the page you are looking for is missing. Try going back to the previous page or try contacting our support for assistance.'
  } else if (error?.code && (error?.code === 401 || error?.code === 403)) {
    header = 'Are you lost?'
    description =
      error.message ||
      'Looks like you are missing permissions to view this. Try logging out and logging into the correct account or try contacting our support for assistance..'
  }
  let colSize: string = 'col'
  switch (size) {
    case 'lg':
      colSize = 'col'
      break
    case 'md':
      colSize = 'col-sm-8 col-md-6'
      break
    case 'sm':
      colSize = 'col-10 col-md-8 col-lg-6'
      break
    default:
      break
  }
  const alignClassName =
    align === 'left'
      ? 'justify-content-start text-start'
      : align === 'center'
      ? 'justify-content-center text-center'
      : 'justify-content-end text-end'

  return (
    <div {...props} className={['row', alignClassName, props.className].filter(Boolean).join(' ')}>
      <div className={colSize}>
        {size !== 'xs' && (
          <img
            src={image || UndrawSorry}
            alt={header}
            className="img-fluid px-5"
            onClick={() => setIsDevCount((c) => c + 1)}
          />
        )}
        <div className="img-fluid">
          {size !== 'xs' && <h4 className="mt-3">{header}</h4>}
          <div className="mb-2">{description}</div>
          {isDevCount > 8 && (
            <div>
              <pre className="small mb-3" style={{ maxHeight: '340px', overflow: 'auto' }}>
                {stack || 'No error stack'}
              </pre>
            </div>
          )}
          {!hideButton && (
            <div>
              {children || (
                <Link to={ROUTES.DASHBOARD} className="btn btn-outline-primary">
                  <FontAwesomeIcon className="me-2" icon={faArrowLeft} />
                  Go back home
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
